const actions = {
  SET_INCREMENT: 'SET_INCREMENT',
  SET_DECREMENT: 'SET_DECREMENT',
  SET_LOGGED_IN_STATUS: 'SET_LOGGED_IN_STATUS',
  UPDATE_SWAPPED_POSITION_COUNT: 'UPDATE_SWAPPED_POSITION_COUNT',
  HOVER_SOURCE_METRIC_RELATION: 'HOVER_SOURCE_METRIC_RELATION',

};

export default actions;
